(() => {
  // --- UTILS ---
  function trackQuizEvent(eventName, params = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': eventName, ...params });
    if (typeof gtag === 'function') gtag('event', eventName, params);
  }

  function formatMoney(cents) {
    if (!cents && cents !== 0) return '';
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'COP'
    }).format(cents / 100);
  }

  function getFeaturedImage(product) {
    if (!product) return '';
    if (product.featured_image) return product.featured_image;
    if (product.images && product.images.length) return product.images[0];
    return '';
  }

  function initQuiz(root) {
    const stepsWrap = root.querySelector('[data-hpp-steps]');
    const progress = root.querySelector('[data-hpp-progress]');
    const mapEl = root.querySelector('[data-hpp-map]');
    if (!stepsWrap || !mapEl) return;

    let map;
    try { map = JSON.parse(mapEl.textContent); } catch (e) { map = {}; }

    const steps = Array.from(root.querySelectorAll('.hpp-step'));
    const questionSteps = steps.filter(s => s.dataset.step !== 'result');
    const totalQ = questionSteps.length;
    
    let history = [];
    let current = '1';
    let isAnimating = false;
    
    // 🔥 NUEVO: Objeto para guardar las respuestas de texto
    let userAnswers = {}; 

    const setProgress = () => {
      if (!progress) return;
      
      let pct = 25; // Estado inicial (Paso 1)
      
      if (current === 'result') {
        pct = 100; // Si llegó al final, 100%
      } else {
        // Por cada paso que dé (guardado en history), suma progreso
        pct = Math.min(95, 25 + (history.length * 35));
      }
      
      progress.style.width = pct + '%';
    };

    const show = (stepKey) => {
      current = String(stepKey);
      steps.forEach(s => s.classList.toggle('is-active', s.dataset.step === current));
      setProgress();
      
      const headerOffset = 50; 
      const elementPosition = root.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    };

    const renderResult = (key) => {
      const cfg = map[key];
      if (!cfg) return;

      // ... Elementos UI existentes ...
      const lineTitleEl = root.querySelector('[data-result-line-title]');
      const lineImgEl = root.querySelector('[data-result-line-img]');
      const prodEl = root.querySelector('[data-result-product]');
      const priceEl = root.querySelector('[data-result-price]');
      const imgEl = root.querySelector('[data-result-img]');
      const prodUrlEl = root.querySelector('[data-result-product-url]');
      const colUrlEl = root.querySelector('[data-result-collection-url]');
      
      // 🔥 NUEVO: Botón de WhatsApp
      const waBtn = root.querySelector('[data-whatsapp-link]');

      const product = cfg.product || null;
      const collection = cfg.collection || null;

      // 1. Renderizar Héroe
      if (lineTitleEl) lineTitleEl.textContent = cfg.label || '';
      if (lineImgEl) {
         if (cfg.line_img && cfg.line_img !== "null") {
           lineImgEl.src = cfg.line_img;
           lineImgEl.style.display = 'block';
         } else {
           lineImgEl.style.display = 'none';
         }
      }

      // 2. Renderizar Producto
      if (prodEl) prodEl.textContent = product ? product.title : '';
      if (priceEl) priceEl.textContent = (product && product.variants) ? formatMoney(product.variants[0].price) : '';

      if (imgEl) {
        const src = getFeaturedImage(product);
        if (src) {
          imgEl.src = src; imgEl.style.display = 'block';
        } else { imgEl.style.display = 'none'; }
      }

      if (prodUrlEl) prodUrlEl.href = product ? `/products/${product.handle}` : '#';
      if (colUrlEl) colUrlEl.href = collection ? `/collections/${collection.handle}` : '#';

      // 🔥 3. CONSTRUIR ENLACE DE WHATSAPP DINÁMICO 🔥
      if (waBtn && waBtn.dataset.phone) {
        // Obtenemos las respuestas en orden
        const answersList = Object.keys(userAnswers)
          .sort() // Ordenar preguntas 1, 2, 3...
          .map(k => `- ${userAnswers[k]}`)
          .join('\n');

        const message = `Hola! 👋 Acabo de hacer el test capilar en la web.\n\n✨ *Mi Resultado:* ${cfg.label}\n\n📝 *Mis Respuestas:*\n${answersList}\n\nQuisiera asesoría sobre esto.`;
        
        // Creamos la URL codificada
        const waUrl = `https://wa.me/${waBtn.dataset.phone}?text=${encodeURIComponent(message)}`;
        waBtn.href = waUrl;
      }

      // TRACKING
      trackQuizEvent('quiz_completed', {
        result_id: key,
        result_line: cfg.label,
        recommended_product: product ? product.title : 'N/A'
      });
    };

    root.addEventListener('click', (e) => {
      const btn = e.target.closest('button, a');
      if (!btn) return;

      if (btn.matches('[data-restart]')) {
        history = [];
        userAnswers = {}; // 🔥 Limpiar respuestas
        steps.forEach(s => s.querySelectorAll('.hpp-card').forEach(b => b.classList.remove('is-selected')));
        trackQuizEvent('quiz_restart');
        show('1');
        return;
      }

      if (btn.matches('[data-back]')) {
        const prev = history.pop();
        if (prev) show(prev);
        return;
      }

      const card = btn.closest('.hpp-card');
      if (card) {
        if(isAnimating) return;
        isAnimating = true;
        
        card.closest('.hpp-step').querySelectorAll('.hpp-card').forEach(b => b.classList.remove('is-selected'));
        card.classList.add('is-selected');

        const next = card.getAttribute('data-next');
        const resultKey = card.getAttribute('data-result');
        
        // 🔥 GUARDAR RESPUESTA DE TEXTO
        // Buscamos el texto dentro de la tarjeta (span class="hpp-card-txt")
        const txtEl = card.querySelector('.hpp-card-txt');
        const answerText = txtEl ? txtEl.innerText.trim() : 'Selección';
        
        // Guardamos en el objeto usando el número de paso actual como clave
        userAnswers[current] = answerText;

        if (current === '1') trackQuizEvent('quiz_start');
        trackQuizEvent('quiz_answer', { step_number: current, answer_text: answerText });

        setTimeout(() => {
          history.push(current);
          if (next === 'result') {
            renderResult(resultKey);
            show('result');
          } else {
            show(next);
          }
          isAnimating = false;
        }, 400);
      }
    });

    show('1');
  }

  const load = () => {
    document.querySelectorAll('[data-hpp-quiz]').forEach(el => {
      if(el.dataset.init === "true") return;
      initQuiz(el);
      el.dataset.init = "true";
    });
  };

  document.addEventListener('DOMContentLoaded', load);
  document.addEventListener('shopify:section:load', load);
})();